<div class="insufficient-text-notification">
  <div class="notification-dt">
    <div class="notification-left-container">
      <img src="assets/icons/warning/warning-red-24px.svg" alt="Icon/Warning/Red">
    </div>
    <p class="notification-info">
      <strong>Insufficient text content:</strong> Please use the <strong>Text</strong> translation tool instead.
    </p>
  </div>
</div>
